// extracted by mini-css-extract-plugin
export default {"iconStyling":"dotOptionsDropdown_iconStyling__F-OqM","genereteReport":"dotOptionsDropdown_genereteReport__xjB2e","deleteBtn":"dotOptionsDropdown_deleteBtn__IGHsO"};